import { useTranslation } from 'react-i18next';
import type { RecommendationOption } from '../../interfaces/chat';
import { RecommendationCard } from '../RecommendationCard';
import styles from './ResolutionOptionsGroup.module.css';

interface ResolutionOptionsGroupProps {
  recommendations: RecommendationOption[];
}

/**
 * Group header with a count, one `RecommendationCard` per option. Callers
 * should only render this when `recommendations.length > 0` — the empty case
 * is `NoViableOptionNotice`, per invariant #5.
 */
export function ResolutionOptionsGroup({ recommendations }: ResolutionOptionsGroupProps) {
  const { t } = useTranslation();
  if (recommendations.length === 0) return null;

  return (
    <div className={styles.wrap} data-testid="resolution-options">
      <h4 className={styles.heading}>
        {t('ChatbotUI.OrderInsight.ResolutionOptions', { count: recommendations.length })}
      </h4>
      <div className={styles.list}>
        {recommendations.map((option) => (
          <RecommendationCard key={option.optionLabel} option={option} />
        ))}
      </div>
    </div>
  );
}
